// SEQ-180: small pill shown next to the page title when its data came from
// the dev fixture (usePnlAnalytics.ts), never rendered in production. Split
// into its own file, separate from features/pnlAnalytics/pnlAnalyticsFormat.ts,
// so this component file only exports a component (react-refresh/only-export-components).
import { FlaskConical } from "lucide-react";

export function FixtureDataBadge() {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: "0.75rem",
        fontWeight: 700,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        color: "#92400e",
        background: "#fffbeb",
        border: "1px solid rgba(245,158,11,0.35)",
        borderRadius: 20,
        padding: "2px 8px",
      }}
      title="pnl_analytics_query is not deployed yet on this database. Showing fixture data so the page can be reviewed."
    >
      <FlaskConical size={11} />
      Fixture data
    </span>
  );
}
